// document.addEventListener("DOMContentLoaded", () => {
//   let boxes = document.querySelectorAll("div.color_box") ;
//   for(let i=0; i<boxes.length; i++){
//       if(boxes[i].classList.contains("active"))boxes[i].addEventListener("click",turnActive(event) );
//     }
//   console.log("Boxes:"+boxes);
// });


function turnActive(id,event){
  let boxes = document.querySelectorAll("div.color_box") ;
  // let id = event.target;
  if(id.classList.contains("active")){
    id.classList.remove("active");
  }else{
    for(let i=0; i<boxes.length; i++){
      if(boxes[i].classList.contains("active"))boxes[i].classList.remove("active");
    }
    id.classList.add("active");
  }
event.stopPropagation();
    console.log("show boxes")
}

function hideBoxes(){
   let boxes = document.querySelectorAll("div.color_box") ;
    for(let i=0; i<boxes.length; i++){
      if(boxes[i].classList.contains("active")) boxes[i].classList.remove("active");
    }
  }